import firebase from "firebase";

export default {
  getPaymentMethods(customerId) {
    return new Promise((resolve, reject) => {
      firebase
        .functions()
        .httpsCallable("getCustomerPaymentMethods")({
          customerId
        })
        .then(result => {
          if (result.error) {
            reject(result.error);
          } else {
            console.log("result", result);
            resolve(result.data.data);
          }
        });
    });
  }
};
